import FloatButton from '@ifca-root/react-component/src/components/Button/FloatButton'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  CircularProgress,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
  withStyles,
} from '@material-ui/core'
import { MoreVert } from '@material-ui/icons'
import { DeleteDialog } from 'components/Dialog/DeleteDialog'
import { advancedFilterList } from 'components/Filter/AdvancedFilter'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  AcctPermission,
  ApprovalStatus,
  useCheckingFullBillingLazyQuery,
  useDeleteArScheduledBillingMutation,
} from 'generated/graphql'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { formatDate, formatTime } from 'helpers/StringNumberFunction/FormatDate'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { Fragment, useContext, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useHistory, useParams } from 'react-router'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import SubmitterLog from 'assets/icons/GeneralLedger/submitter-log.svg'
import IconText from '@ifca-root/react-component/src/components/Typography/IconText'

export const ARScheduledBillingEntryList = (props: any) => {
  const {
    filteredList,
    ScheduledBillingbyStatusLoading,
    listStatus,
    fetchMore,
    setOriginalListing,
    setErrMessage,
    setErrDialog,
    userList,
  } = props

  const getSearch = JSON.parse(localStorage.getItem('searchFilter'))
  let history = useHistory()
  const { CompanyID, ScheduledBillingSubmenu }: any = useParams()
  const companyStatus = localStorage?.getItem('companyStatus')

  /* -------------------------------------------- */
  /*                     STATE                    */
  /* -------------------------------------------- */
  const { anchorEl, menu, handleClick, handleClose } = useMenuOption()
  const { setOpenSnackBar, setSnackBarMsg } = useContext(SnackBarContext) as any
  const [deleteAA, setDeleteAA] = useState(false)
  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [errMsg, setErrMsg] = useState<string>('')

  /* -------------------------------------------- */
  /*                     QUERY                    */
  /* -------------------------------------------- */
  const [
    deleteScheduledBilling,
    { loading: deleteScheduledBillingLoading },
  ] = useDeleteArScheduledBillingMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: () => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.deleteRecord())
      setOriginalListing([])
      fetchMore({
        variables: {
          CompanyID,
          StatusArr: 'ACTIVE',
          take: 30,
          skip: 0,
          searchValue:
            getSearch?.name === '' || getSearch?.name === undefined
              ? undefined
              : getSearch?.name,
        },
      })
    },
  })
  const AmountTooltip = withStyles({
    tooltip: {
      color: 'white',
      backgroundColor: '#9e9e9e',
    },
    arrow: {
      '&.MuiTooltip-arrow': {
        right: 0,
        color: '#9e9e9e',
        width: '8rem',
      },
    },
  })(Tooltip)
  const [
    checkingBilling,
    {
      loading: CheckingFullBillingLoading,
      data: { checkingFullBilling } = { checkingFullBilling: [] },
    },
  ] = useCheckingFullBillingLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  /* -------------------------------------------- */
  /*                     VARIABLE                 */
  /* -------------------------------------------- */
  const { handlePermDisabled } = usePermissionChecker()

  const handleDelete = data => {
    deleteScheduledBilling({
      variables: { input: { ScheduledBillingID: data } },
    })
    setDeleteAA(false)
  }

  return (
    <>
      {CheckingFullBillingLoading && <Loading />}
      {deleteScheduledBillingLoading && <Loading />}
      {ScheduledBillingbyStatusLoading && <Loading />}
      <ContentWrapper advSearch float>
        <List className="core-list">
          {advancedFilterList(filteredList) === undefined ||
          advancedFilterList(filteredList)?.length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="Add a new record now."
            />
          ) : (
            <InfiniteScroll
              dataLength={filteredList?.length}
              next={() => {
                const currentLength = filteredList?.length
                fetchMore({
                  variables: {
                    CompanyID: CompanyID,
                    StatusArr: [listStatus],
                    take: 30,
                    skip: currentLength,
                    searchValue:
                      getSearch?.name === '' || getSearch?.name === undefined
                        ? undefined
                        : getSearch?.name,
                  },
                })
              }}
              hasMore={true}
              style={{ padding: '8px 6px' }}
              loader={
                ScheduledBillingbyStatusLoading && (
                  <div style={{ textAlign: 'center' }}>
                    <CircularProgress />
                  </div>
                )
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>-</b>
                </p>
              }
            >
              {advancedFilterList(filteredList)?.map((el, index) => {
                return (
                  <ListItem>
                    <ListItemText
                      primary={
                        <>
                          <span className={`xsTitle flex-space`}>
                            {el?.DebtorAccount?.DebtorName}
                          </span>
                          <span
                            className="desc"
                            style={{ justifyContent: 'end' }}
                          >
                            {`${formatDate(el?.createdTs)}`}
                          </span>
                        </>
                      }
                      secondary={
                        <Grid container className="desc flex-space text-noflow">
                          <Grid spacing={1} container className="table-content">
                            <Grid item xs={12}>
                              <span style={{ fontSize: '10px' }}>
                                {el?.SalesOrder?.title}
                              </span>
                            </Grid>
                            {/* <Grid item xs={3}>
                              <IconText
                                parentStyle={{ justifyContent: 'end' }}
                                font="xxTitle c-orange"
                                children={amtStr(
                                  el?.BillingAmt ??
                                    el?.ScheduledBillingItem?.reduce(
                                      (prevValue, currentValue) =>
                                        prevValue + currentValue?.BillingAmt,
                                      0
                                    )
                                )} // please don't change until something is done to the entity - AQIL
                                // discuss with the team on this
                              />
                            </Grid> */}
                          </Grid>
                          <Grid spacing={1} container className="table-content">
                            {listStatus === 'ACTIVE' ? (
                              <>
                                <Grid item xs={12}>
                                  <Tooltip
                                    title={
                                      <React.Fragment>
                                        <Grid
                                          container
                                          wrap="nowrap"
                                          spacing={2}
                                        >
                                          <Grid item xs zeroMinWidth>
                                            {
                                              <div>
                                                <div
                                                  style={{ fontSize: '12px' }}
                                                >
                                                  {`Billing Amount: ${amtStr(
                                                    el?.BillingAmt ??
                                                      el?.ScheduledBillingItem?.reduce(
                                                        (
                                                          prevValue,
                                                          currentValue
                                                        ) =>
                                                          prevValue +
                                                          currentValue?.BillingAmt,
                                                        0
                                                      )
                                                  )}`}
                                                </div>
                                              </div>
                                            }
                                          </Grid>
                                        </Grid>
                                      </React.Fragment>
                                    }
                                    disableFocusListener
                                    arrow
                                    enterTouchDelay={0}
                                  >
                                    <span
                                      style={{
                                        fontSize: '10px',
                                        color: 'orange',
                                      }}
                                    >
                                      {amtStr(
                                        el?.BillingAmt ??
                                          el?.ScheduledBillingItem?.reduce(
                                            (prevValue, currentValue) =>
                                              prevValue +
                                              currentValue?.BillingAmt,
                                            0
                                          )
                                      )}
                                    </span>
                                  </Tooltip>
                                </Grid>
                              </>
                            ) : listStatus === 'COMPLETED' ? (
                              <Grid item xs={9}>
                                <>
                                  <div>
                                    <Tooltip
                                      title={
                                        <React.Fragment>
                                          <Grid
                                            container
                                            wrap="nowrap"
                                            spacing={2}
                                          >
                                            <Grid item xs zeroMinWidth>
                                              {
                                                <div>
                                                  <div
                                                    style={{ fontSize: '12px' }}
                                                  >
                                                    {`Unbilled Amount: ${amtStr(
                                                      Math.max(
                                                        0,
                                                        Number(
                                                          el?.SalesOrder
                                                            ?.revisedOrderSum ||
                                                            el?.SalesOrder
                                                              ?.orderSum ||
                                                            0
                                                        ) -
                                                          Number(
                                                            el?.ScheduledBillingItem?.filter(
                                                              item =>
                                                                item.isBilled ===
                                                                true
                                                            )?.reduce(
                                                              (sum, item) =>
                                                                sum +
                                                                (item?.BillingAmt ??
                                                                  0),
                                                              0
                                                            ) ?? 0
                                                          )
                                                      )
                                                    )}`}
                                                  </div>
                                                  <div
                                                    style={{ fontSize: '12px' }}
                                                  >
                                                    {`Billed Amount: ${amtStr(
                                                      el?.BillingAmt ??
                                                        el?.ScheduledBillingItem?.filter(
                                                          item =>
                                                            item.isBilled ===
                                                            true
                                                        )?.reduce(
                                                          (
                                                            prevValue,
                                                            currentValue
                                                          ) =>
                                                            prevValue +
                                                            currentValue?.BillingAmt,
                                                          0
                                                        )
                                                    )}`}
                                                  </div>
                                                </div>
                                              }
                                            </Grid>
                                          </Grid>
                                        </React.Fragment>
                                      }
                                      disableFocusListener
                                      arrow
                                      enterTouchDelay={0}
                                    >
                                      <span style={{ display: 'inline-block' }}>
                                        <span
                                          style={{
                                            fontSize: '10px',
                                            color: 'orange',
                                          }}
                                        >
                                          {amtStr(
                                            Math.max(
                                              0,
                                              Number(
                                                el?.SalesOrder
                                                  ?.revisedOrderSum ||
                                                  el?.SalesOrder?.orderSum ||
                                                  0
                                              ) -
                                                Number(
                                                  el?.ScheduledBillingItem?.filter(
                                                    item =>
                                                      item.isBilled === true
                                                  )?.reduce(
                                                    (sum, item) =>
                                                      sum +
                                                      (item?.BillingAmt ?? 0),
                                                    0
                                                  ) ?? 0
                                                )
                                            )
                                          )}
                                        </span>
                                        {'  '}|{'  '}
                                        <span
                                          style={{
                                            fontSize: '10px',
                                            color: 'orange',
                                          }}
                                        >
                                          {amtStr(
                                            el?.BillingAmt ??
                                              el?.ScheduledBillingItem?.filter(
                                                item => item.isBilled === true
                                              )?.reduce(
                                                (prevValue, currentValue) =>
                                                  prevValue +
                                                  currentValue?.BillingAmt,
                                                0
                                              )
                                          )}
                                        </span>
                                      </span>
                                    </Tooltip>
                                  </div>
                                </>
                              </Grid>
                            ) : null}
                          </Grid>

                          <Grid spacing={1} container className="table-content">
                            <Grid item xs={12}>
                              {
                                <div className="icon-text">
                                  <Tooltip
                                    disableFocusListener
                                    title={
                                      <Fragment>
                                        <Grid
                                          container
                                          wrap="nowrap"
                                          spacing={2}
                                        >
                                          <Grid item>
                                            <IconText
                                              icon={
                                                <img
                                                  src={SubmitterLog}
                                                  style={{
                                                    width: '12px',
                                                    marginRight: '3px',
                                                  }}
                                                />
                                              }
                                              font="desc"
                                            />
                                          </Grid>
                                          <Grid item xs zeroMinWidth>
                                            <div style={{ fontSize: '12px' }}>
                                              {userList?.find(
                                                x => x?.ID === el?.approvedBy
                                              )?.name ??
                                                userList?.find(
                                                  x => x?.ID === el?.createdBy
                                                )?.name}
                                            </div>
                                            <div style={{ fontSize: '10px' }}>
                                              {formatDate(
                                                el?.approvedTs ?? el?.createdTs
                                              )}{' '}
                                              &nbsp;
                                              {formatTime(
                                                el?.approvedTs ?? el?.createdTs
                                              )}
                                            </div>
                                          </Grid>
                                        </Grid>
                                      </Fragment>
                                    }
                                    arrow
                                    enterTouchDelay={0}
                                  >
                                    <div>
                                      <IconText
                                        icon={
                                          <img
                                            src={SubmitterLog}
                                            style={{
                                              width: '12px',
                                              marginRight: '3px',
                                            }}
                                          />
                                        }
                                        font="desc"
                                      />
                                    </div>
                                  </Tooltip>
                                  <span className="desc text-noflow">
                                    {!el?.SalesOrder?.remarks?.trim()
                                      ? ''
                                      : el.SalesOrder.remarks}
                                  </span>
                                </div>
                              }
                            </Grid>
                          </Grid>
                        </Grid>
                      }
                    />
                    <ListItemSecondaryAction>
                      {/* {listStatus === 'ACTIVE' || listStatus === 'REJECTED' ? ( */}
                      <>
                        <IconButton
                          edge="end"
                          aria-label="delete"
                          aria-controls="menu-list"
                          aria-haspopup="true"
                          onClick={e => {
                            handleClick(e, el?.ScheduledBillingID, index, el)
                            if (
                              el?.ApprovalStatus === ApprovalStatus.Completed
                            ) {
                              checkingBilling({
                                variables: {
                                  ScheduledBillingID: el?.ScheduledBillingID,
                                },
                              })
                            }
                          }}
                        >
                          <MoreVert />
                        </IconButton>
                      </>
                      {/* ) : (
                        <IconButton edge="end" aria-label="arrow">
                          <KeyboardArrowRight
                            onClick={() =>
                              history.push({
                                pathname: `/account-receivable/${CompanyID}/scheduled-billing/sales-order/${el?.ScheduledBillingID}/detail`,
                                state: el,
                              })
                            }
                          />
                        </IconButton>
                      )} */}
                    </ListItemSecondaryAction>
                  </ListItem>
                )
              })}
            </InfiniteScroll>
          )}
        </List>
        {listStatus === 'ACTIVE' && (
          <FloatButton
            onClick={() => {
              history.push(
                `/account-receivable/${CompanyID}/scheduled-billing/sales-order/add`
              )
            }}
            disabled={
              handlePermDisabled({
                companyID: CompanyID,
                permEnum:
                  AcctPermission.AccReceivableSalesOrderBillingScheduleCreate,
              })
                ? true
                : false
            }
          />
        )}
      </ContentWrapper>

      {(listStatus === 'ACTIVE' || listStatus === 'COMPLETED') && (
        <Menu
          id="menu-list"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          onClick={handleClose}
        >
          <>
            {listStatus === 'COMPLETED' && (
              <MenuItem
                disabled={handlePermDisabled({
                  companyID: CompanyID,
                  permEnum:
                    AcctPermission.AccReceivableSalesOrderBillingScheduleView,
                })}
                onClick={() =>
                  history.push({
                    pathname: `/account-receivable/${CompanyID}/scheduled-billing/sales-order/${menu?.obj?.ScheduledBillingID}/detail`,
                    state: menu?.obj,
                  })
                }
              >
                View
              </MenuItem>
            )}
            {(listStatus === 'ACTIVE' ||
              (listStatus === 'COMPLETED' &&
                (checkingFullBilling?.hasUnbilledItems ||
                  checkingFullBilling?.isAllowedAddBill))) && (
              <MenuItem
                // disabled=
                // {handlePermDisabled({
                //   companyID: CompanyID,
                //   permEnum:
                //     AcctPermission.AccReceivableSalesOrderBillingScheduleUpdate,
                // })}
                onClick={() => {
                  history.push({
                    pathname: `/account-receivable/${CompanyID}/scheduled-billing/sales-order/${menu?.obj?.ScheduledBillingID}/edit`,
                    state: menu?.obj,
                  })
                }}
              >
                Edit
              </MenuItem>
            )}
            {listStatus === 'ACTIVE' && (
              <MenuItem
                disabled={handlePermDisabled({
                  companyID: CompanyID,
                  permEnum:
                    AcctPermission.AccReceivableSalesOrderBillingScheduleDelete,
                })}
                onClick={() => setDeleteAA(true)}
              >
                Delete
              </MenuItem>
            )}
          </>

          {/* {listStatus === ApprovalStatus.Rejected && (
            <MenuItem
              onClick={() =>
                history.push({
                  pathname: `/account-receivable/${CompanyID}/scheduled-billing/sales-order/${menu?.obj?.ScheduledBillingID}/edit`,
                  state: { ...menu?.obj, mode: 'resubmit' },
                })
              }
              disabled={
                companyStatus === 'INACTIVE' ||
                handlePermDisabled({
                  companyID: CompanyID,
                  permEnum:
                    AcctPermission.AccReceivableSalesOrderBillingScheduleUpdate,
                })
              }
            >
              Resubmit
            </MenuItem>
          )} */}
        </Menu>
      )}

      <DeleteDialog
        ID={menu?.ID}
        openDeleteDialog={deleteAA}
        setOpenDeleteDialog={setDeleteAA}
        title={'Schedule Billing'}
        menu={menu?.obj}
        handleDelete={handleDelete}
        passID={menu?.ID}
      />

      <ErrorDialog
        errorDia={errorDia}
        setErrorDia={setErrorDia}
        errorMsg={errMsg}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
